import { FC, useContext, useEffect, useRef, useState } from 'react';

import { BottomIcon, Button, TopIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { ESyncScope } from 'types';

import { SaveButtonProps } from './interfaces';
import s from './SaveButton.module.scss';

export const SaveButton: FC<SaveButtonProps> = ({
  onSave,
  disabled,
  loading,
}) => {
  const { t } = useContext(LocalizationContext);
  const dropdownDeleteRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        isOpen &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={wrapperRef} className={s.button_block}>
      <Button
        variant="primary"
        onClick={() => setIsOpen(!isOpen)}
        fullWidth
        disabled={disabled}
        isLoading={loading}
        className={cn(s.button, isOpen && s.active)}
      >
        {t('group.modal.save.button')}
        <div className={s.arrow} onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? (
            <TopIcon size="l" color={disabled ? 'disable' : 'light'} />
          ) : (
            <BottomIcon size="l" color={disabled ? 'disable' : 'light'} />
          )}
        </div>
      </Button>

      {isOpen && (
        <div ref={dropdownDeleteRef} className={s.dropdown}>
          <div
            className={s.drop_item}
            onClick={() => {
              onSave(ESyncScope.LOCAL);
              setIsOpen(false);
            }}
          >
            {t('application.manager.button_3')}
          </div>
          <div
            className={s.drop_item}
            onClick={() => {
              onSave(ESyncScope.NETWORK);
              setIsOpen(false);
            }}
          >
            {t('application.manager.button_4')}
          </div>
        </div>
      )}
    </div>
  );
};
